import { render, staticRenderFns } from "./Chronology.vue?vue&type=template&id=64dedc48"
import script from "./Chronology.vue?vue&type=script&lang=js"
export * from "./Chronology.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports